import { FC, ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { cvaPortalOverlay } from '~/shared/ui/Portal/PortalStyles';

interface IPortalProps {
  children: ReactNode;
  className?: string;
  opacity?: boolean;
}

export const Portal: FC<IPortalProps> = ({
  children,
  className,
  opacity = true,
}) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const el = document.createElement('div');
      const overlay = document.createElement('div');
      overlay.className = opacity
        ? cvaPortalOverlay() + ' bg-opacity-80'
        : cvaPortalOverlay();
      el.className = className ?? 'Portal';
      overlay.appendChild(el);
      document.body.appendChild(overlay);
      setContainer(el);

      return () => {
        try {
          document.body.removeChild(overlay);
        } catch (e) {
          console.warn(e);
        }
      };
    }
  }, []);

  if (!container) return null;

  return createPortal(children, container);
};
